@let userValue = user();
@if (userValue && (userValue.status === 'active' || userValue.status === 'mandatory-flow')) {
    @if (userValue.status === 'active' && canShare) {
      <p-button severity="secondary" size="small" label="Share" icon="pi pi-share-alt"
                (onClick)="onShareClick()">
      </p-button>
    }
    <a pButton [outlined]="true" [text]="true" [routerLink]="['/account'] ">
      <i pButtonIcon class="pi pi-user text-surface-950"></i>
    </a>
}
